
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'NativeAppUsersHeader'
})
export default class extends Vue {}
